
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hjyA9", function(module, exports) {

$parcel$export(module.exports, "NO_DATA_PLACEHOLDER", () => $7ecc43a78c6b5753$export$752740b4377c7819);
$parcel$export(module.exports, "sortByState", () => $7ecc43a78c6b5753$export$5359594223d2611f);
$parcel$export(module.exports, "AnalyticsTableUIState", () => $7ecc43a78c6b5753$export$611eb6518a3b156e);
$parcel$export(module.exports, "getTableUIState", () => $7ecc43a78c6b5753$export$22a0f52d870655f7);
const $7ecc43a78c6b5753$export$752740b4377c7819 = "\u2014";
const $7ecc43a78c6b5753$export$5359594223d2611f = (sorting)=>(rowA, rowB)=>{
        if (!sorting) return 0;
        const valueA = rowA.data[sorting.field];
        const valueB = rowB.data[sorting.field];
        // Handle numerical values
        const isNumberA = typeof valueA === 'number';
        const isNumberB = typeof valueB === 'number';
        if (isNumberA && isNumberB) return sorting.direction === 'asc' ? valueA - valueB : valueB - valueA;
        // For ISO dates and other strings, fallback to string comparison
        const stringA = String(valueA).toLowerCase();
        const stringB = String(valueB).toLowerCase();
        if (stringA < stringB) return sorting.direction === 'asc' ? -1 : 1;
        if (stringA > stringB) return sorting.direction === 'asc' ? 1 : -1;
        return 0;
    };
var $7ecc43a78c6b5753$export$611eb6518a3b156e = /*#__PURE__*/ function(AnalyticsTableUIState) {
    AnalyticsTableUIState["Error"] = "Error";
    AnalyticsTableUIState["Loading"] = "Loading";
    AnalyticsTableUIState["Filtering"] = "Filtering";
    AnalyticsTableUIState["NoFilterResults"] = "NoFilterResults";
    AnalyticsTableUIState["Data"] = "Data";
    AnalyticsTableUIState["Empty"] = "Empty";
    return AnalyticsTableUIState;
}({});
const $7ecc43a78c6b5753$export$22a0f52d870655f7 = (props, table)=>{
    if (Boolean(props.hasError)) return "Error";
    if (Boolean(props.isLoading)) return "Loading";
    if (Boolean(props.isFiltering) && table.rows.length === 0) return "NoFilterResults";
    if (Boolean(props.isFiltering)) return "Filtering";
    if (table.rows.length === 0) return "Empty";
    return "Data";
};

});

parcelRegister("1H4PD", function(module, exports) {

$parcel$export(module.exports, "sharedI18n", () => $31e44be9f1aeca8d$export$3f5b411add82afdd);

var $2nPZH = parcelRequire("2nPZH");
const $31e44be9f1aeca8d$export$3f5b411add82afdd = (0, $2nPZH.defineMessages)({
    serverErrorMessageTitle: {
        id: "confluence-analytics.server-error-message.title",
        defaultMessage: "We couldn\u2019t retrieve your data."
    },
    serverErrorMessageDescription: {
        id: "confluence-analytics.server-error-message.description",
        defaultMessage: "Please reload or contact your site administrator."
    },
    serverErrorExpandedDescription: {
        id: "confluence-analytics.server-error-message.expanded-description",
        defaultMessage: "(Error: {errorMessage})"
    },
    // Filters
    resetAllButtonText: {
        id: "confluence-analytics.filters.reset-all-button-text",
        defaultMessage: "Reset all"
    },
    dateOption7D: {
        id: "confluence-analytics.filters.date-option-7D",
        defaultMessage: "7D"
    },
    dateOption1M: {
        id: "confluence-analytics.filters.date-option-1M",
        defaultMessage: "1M"
    },
    dateOption3M: {
        id: "confluence-analytics.filters.date-option-3M",
        defaultMessage: "3M"
    },
    dateOptionYTD: {
        id: "confluence-analytics.filters.date-option-YTD",
        defaultMessage: "YTD"
    },
    dateOptionAllTime: {
        id: "confluence-analytics.filters.date-option-all-time",
        defaultMessage: "All-time"
    },
    dateOptionCustom: {
        id: "confluence-analytics.filters.date-option-custom",
        defaultMessage: "Custom date range"
    },
    dateOption7DExpanded: {
        id: "confluence-analytics.filters.date-option-7D-expanded-form",
        defaultMessage: "Last 7 days"
    },
    dateOption1MExpanded: {
        id: "confluence-analytics.filters.date-option-1M-expanded-form",
        defaultMessage: "Last 1 month"
    },
    dateOption3MExpanded: {
        id: "confluence-analytics.filters.date-option-3M-expanded-form",
        defaultMessage: "Last 3 months"
    },
    dateOptionYTDExpanded: {
        id: "confluence-analytics.filters.date-option-YTD-expanded-form",
        defaultMessage: "Year to date"
    },
    dateOptionAllTimeOneYearDateLimit: {
        id: "confluence-analytics.filters.date-option-all-time-expanded-form.one-year-limit",
        defaultMessage: "Starting from {startDate} (Data available for up to 1 year.)"
    },
    dateOptionAllTimeCreationDateLimit: {
        id: "confluence-analytics.filters.date-option-all-time-expanded-form.creation-date-limit",
        defaultMessage: "Starting from {startDate} (Creation date.)"
    },
    // Site analytics
    exportCSVButtonTitle: {
        id: "confluence-analytics.export-csv-button-title",
        defaultMessage: "Export as CSV"
    },
    spaceIconLabel: {
        id: "confluence-analytics.popular-spaces-card.space-icon-label",
        defaultMessage: "Space logo for {spaceName}"
    },
    userSearchPlaceholder: {
        id: "confluence-analytics.users-table.user-search-placeholder",
        defaultMessage: "Search users"
    }
});

});

parcelRegister("llOW5", function(module, exports) {

$parcel$export(module.exports, "AnalyticsTable", () => $e3fcf393cb29fb6d$export$25b928a82634a933);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $ccHMk = parcelRequire("ccHMk");

var $22Iw9 = parcelRequire("22Iw9");

var $3gadb = parcelRequire("3gadb");

var $euUgw = parcelRequire("euUgw");

var $kpYGL = parcelRequire("kpYGL");

var $iEKnc = parcelRequire("iEKnc");

var $21pnI = parcelRequire("21pnI");

var $jhwJP = parcelRequire("jhwJP");

var $1H4PD = parcelRequire("1H4PD");

var $lsKPt = parcelRequire("lsKPt");

var $hOfan = parcelRequire("hOfan");

var $h4JwO = parcelRequire("h4JwO");

var $d07OI = parcelRequire("d07OI");

var $hjyA9 = parcelRequire("hjyA9");
const $e3fcf393cb29fb6d$var$i18nBase = (0, $2nPZH.defineMessages)({
    analyticsTableSortAscIcon: {
        id: "confluence-analytics.analytics-table.sort-asc-icon",
        defaultMessage: "Sort in ascending order"
    },
    analyticsTableSortDescIcon: {
        id: "confluence-analytics.analytics-table.sort-desc-icon",
        defaultMessage: "Sort in descending order"
    },
    analyticsTableEmptyStateMessage: {
        id: "confluence-analytics.analytics-table.empty-state-message",
        defaultMessage: "This page hasn\u2019t been viewed since Analytics started tracking activity."
    },
    analyticsTableNoResultsStateMessage: {
        id: "confluence-analytics.analytics-table.no-results-state-message",
        defaultMessage: "No results found"
    }
});
const $e3fcf393cb29fb6d$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    analyticsTableEmptyStateMessage: {
        id: "confluence-analytics.analytics-table.empty-state-message.livedocs",
        defaultMessage: "This page or doc hasn\u2019t been viewed since Analytics started tracking activity."
    }
});
const $e3fcf393cb29fb6d$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($e3fcf393cb29fb6d$var$i18nBase, $e3fcf393cb29fb6d$var$i18nLiveDocs);
const $e3fcf393cb29fb6d$var$inlineTextStyles = (0, $ecnYn.xcss)({
    display: 'inline'
});
const $e3fcf393cb29fb6d$var$ColumnHeaderAlignmentWrapper = ({ alignment: alignment, children: children })=>{
    if (alignment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        justifyContent: alignment
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};
const $e3fcf393cb29fb6d$export$25b928a82634a933 = (props)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const table = (0, $21pnI.useCharlieTable)({
        columns: props.columns,
        rows: props.rows
    });
    const currentUIState = (0, $hjyA9.getTableUIState)(props, table);
    const tableBodySectionTestId = props.testId && `${props.testId}-section--${currentUIState}`;
    const configIconStyle = (isSortingActive)=>{
        if (currentUIState === (0, $hjyA9.AnalyticsTableUIState).Loading) return "var(--ds-icon-subtlest, #626F86)";
        else if (isSortingActive) return "var(--ds-icon-selected, #0C66E4)";
        return "var(--ds-icon-subtle, #626F86)";
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lsKPt.Table), {
        testId: props.testId,
        "aria-label": props.ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hOfan.TableSection), {
        as: "thead"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h4JwO.TableRow), null, table.getColumnsInOrder().map((column)=>{
        const isDisabled = currentUIState === (0, $hjyA9.AnalyticsTableUIState).Empty || currentUIState === (0, $hjyA9.AnalyticsTableUIState).Loading || currentUIState === (0, $hjyA9.AnalyticsTableUIState).Error || currentUIState === (0, $hjyA9.AnalyticsTableUIState).NoFilterResults;
        const isSortingActive = !isDisabled && props.sortingState?.field === column.key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d07OI.TableCell), {
            as: "th",
            key: column.key,
            size: props.getColumnSize?.(column)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e3fcf393cb29fb6d$var$ColumnHeaderAlignmentWrapper, {
            alignment: props.getColumnHeaderAlignment?.(column)
        }, !column.isSortable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, column.content), column.isSortable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            content: column.content
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
                ...tooltipProps,
                isDisabled: isDisabled,
                iconAfter: ()=>isSortingActive && props.sortingState?.direction === 'asc' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
                        color: configIconStyle(isSortingActive),
                        label: formatMessage($e3fcf393cb29fb6d$var$i18n.analyticsTableSortAscIcon)
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($22Iw9))), {
                        color: configIconStyle(isSortingActive),
                        label: formatMessage($e3fcf393cb29fb6d$var$i18n.analyticsTableSortDescIcon)
                    }),
                appearance: "subtle",
                spacing: "compact",
                isSelected: isSortingActive,
                onClick: ()=>{
                    props.onSortChange?.({
                        field: column.key,
                        direction: props.sortingState?.direction === 'asc' ? 'desc' : 'asc'
                    });
                }
            }, column.content))));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hOfan.TableSection), {
        as: "tbody",
        testId: tableBodySectionTestId
    }, currentUIState === (0, $hjyA9.AnalyticsTableUIState).Error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h4JwO.TableRow), {
        noBorder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d07OI.TableCell), {
        as: "td",
        size: "full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iEKnc))), {
        label: formatMessage((0, $1H4PD.sharedI18n).serverErrorMessageTitle),
        color: "var(--ds-icon-warning, #E56910)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $e3fcf393cb29fb6d$var$inlineTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $1H4PD.sharedI18n).serverErrorMessageTitle), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $1H4PD.sharedI18n).serverErrorMessageDescription))))), currentUIState === (0, $hjyA9.AnalyticsTableUIState).Loading && Array.from({
        length: props.rowsPerPage || 5
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h4JwO.TableRow), {
            key: index,
            noBorder: index + 1 === 5
        }, table.getColumnsInOrder().map((column)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d07OI.TableCell), {
                as: "td",
                key: column.key,
                size: props.getColumnSize?.(column)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kpYGL.default), {
                width: "100%",
                height: "16px",
                isShimmering: true
            }))))), currentUIState === (0, $hjyA9.AnalyticsTableUIState).NoFilterResults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h4JwO.TableRow), {
        noBorder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d07OI.TableCell), {
        as: "td"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $e3fcf393cb29fb6d$var$i18n.analyticsTableNoResultsStateMessage))), currentUIState === (0, $hjyA9.AnalyticsTableUIState).Empty && (props.emptyComponent || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h4JwO.TableRow), {
        noBorder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d07OI.TableCell), {
        as: "td"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $e3fcf393cb29fb6d$var$i18n.analyticsTableNoResultsStateMessage)))), (currentUIState === (0, $hjyA9.AnalyticsTableUIState).Data || currentUIState === (0, $hjyA9.AnalyticsTableUIState).Filtering) && table.rows.map((row, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h4JwO.TableRow), {
            key: row.id,
            testId: props.testId && `${props.testId}-row-${index}`,
            noBorder: index + 1 === table.rows.length,
            isSelected: index === props.activeRowIndex,
            isDataRow: true,
            onClick: props.onRowClick ? ()=>{
                props.onRowClick?.(row, index);
            } : undefined
        }, table.getColumnsInOrder().map((column)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d07OI.TableCell), {
                as: "td",
                key: column.key,
                size: props.getColumnSize?.(column),
                isSortable: column.isSortable
            }, column.cell.render(row.data)))))));
};

});
parcelRegister("21pnI", function(module, exports) {

$parcel$export(module.exports, "useCharlieTable", () => $6f771d1273db44c7$export$dca832df5e5219b);
/**
 * useCharlieTable is a custom hook that returns the table state and the table actions
 * similar to the tanstack table hook. The idea here is to provide similar functionality
 * while allowing the functionality to be upstreams back into the @atlaskit/table
 * if they find it acceptable.
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $6G1uJ = parcelRequire("6G1uJ");

var $ablid = parcelRequire("ablid");
const $6f771d1273db44c7$export$886404f422f393c4 = {
    width: 150,
    minWidth: 40,
    maxWidth: Number.MAX_SAFE_INTEGER
};
const $6f771d1273db44c7$export$88956207daf9a17e = 'asc';
const $6f771d1273db44c7$export$bc14f97913aaf2a = 'desc';
const $6f771d1273db44c7$var$useStateManagement = (options)=>{
    const initialState = {
        ...options.initialState,
        columnOrder: options.initialState?.columnOrder ?? options.columns?.map((column)=>column.key)
    };
    const [internalState, setInternalState] = (0, $gwFzn.useState)(initialState);
    const updateTableState = (key, updater, externalCallback)=>{
        setInternalState((prevState)=>{
            const currentValue = prevState[key];
            const updatedValue = typeof updater === 'function' ? updater(currentValue) : updater;
            // Optionally, call the external callback with the new value
            if (externalCallback) externalCallback(updatedValue);
            return {
                ...prevState,
                [key]: updatedValue
            };
        });
    };
    // This allows the component to either use the internal state or a provided state
    const getState = ()=>({
            ...internalState,
            ...options.state
        });
    return {
        getState: getState,
        updateTableState: updateTableState
    };
};
// Column handling utilities
const $6f771d1273db44c7$var$useColumnUtils = ({ options: options, getState: getState, updateTableState: updateTableState })=>{
    // Sorting utilities
    const setSorting = (newSorting)=>{
        updateTableState('sorting', newSorting, options.onSortChange);
    };
    const getSorting = ()=>getState().sorting;
    const toggleSorting = (column)=>{
        const currentSorting = getSorting();
        if (!currentSorting || getIsCurrentSort(column) === false) setSorting({
            field: column.sortField ?? column.key,
            direction: $6f771d1273db44c7$export$88956207daf9a17e
        });
        else setSorting({
            ...currentSorting,
            direction: currentSorting.direction === $6f771d1273db44c7$export$88956207daf9a17e ? $6f771d1273db44c7$export$bc14f97913aaf2a : $6f771d1273db44c7$export$88956207daf9a17e
        });
    };
    const getIsCurrentSort = (column)=>{
        return getSorting()?.field === (column.sortField ?? column.key);
    };
    // Column order utilities
    const setColumnOrder = (newColumnOrder)=>{
        updateTableState('columnOrder', newColumnOrder, options.onColumnOrderChange);
    };
    const getColumnsInOrder = (0, $gwFzn.useCallback)(()=>{
        return getState().columnOrder.flatMap((columnId)=>{
            const column = options.columns.find((column)=>column.key === columnId);
            return column ? [
                column
            ] : [];
        });
    }, [
        getState,
        options.columns
    ]);
    /**
	 * Gets the index of a column in the columnOrder array.
	 * @param columnKey -- the key of the column to find the index of
	 * @returns number -- the index of the column in the columnOrder array
	 */ const getColumnIndex = (0, $gwFzn.useCallback)((column)=>{
        return getColumnsInOrder().findIndex((columnInOrder)=>column.key === columnInOrder.key);
    }, [
        getColumnsInOrder
    ]);
    const getVisibleColumns = (0, $gwFzn.useCallback)(()=>getColumnsInOrder().filter((column)=>!column?.isHidden), [
        getColumnsInOrder
    ]);
    const getColumnOrder = ()=>getState().columnOrder;
    // Column width utilities
    /**
	 * Sets the columnWidths state for the table.
	 * Intended for internal use or overriding the state, setColumnWidth (singular) preferred for column width changes.
	 * @param newColumnWidths -- the new columnWidths state
	 */ const setColumnWidths = (newColumnWidths)=>{
        updateTableState('columnWidths', newColumnWidths, options.onColumnWidthsChange);
    };
    /**
	 * Preferred method of changing the column width for a column.
	 * @param column -- the column to set the width for
	 * @param width -- the new width for the column
	 */ const setColumnWidth = ({ column: column, width: width })=>{
        setColumnWidths((prevColumnWidths)=>{
            return {
                ...prevColumnWidths,
                [column.key]: width
            };
        });
    };
    /**
	 * @returns the columnWidths state for the table
	 */ const getColumnWidths = ()=>getState().columnWidths;
    /**
	 * Gets the width of a column, clamped between the min and max width.
	 * @param column -- the column to get the width for
	 * @returns number -- the width of the column
	 */ const getColumnWidth = (0, $gwFzn.useCallback)((column)=>{
        const defaultColWidth = options.defaultColumnWidths ?? $6f771d1273db44c7$export$886404f422f393c4;
        return Math.max(column.minWidth ?? defaultColWidth.minWidth, Math.min(getState().columnWidths?.[column.key] ?? column.width ?? defaultColWidth.width, column.maxWidth ?? defaultColWidth.maxWidth));
    }, [
        getState,
        options.defaultColumnWidths
    ]);
    /**
	 * Gets the total width of all columns visible in the table.
	 * Useful for setting the width of the table container when tableLayout is fixed.
	 * @returns number -- the total width of all columns visible in the table
	 */ const getTotalTableWidth = (0, $gwFzn.useCallback)(()=>{
        return getColumnsInOrder().reduce((sum, column)=>{
            if (column == null) return sum;
            return sum + getColumnWidth(column);
        }, 0) ?? 0;
    }, [
        getColumnWidth,
        getColumnsInOrder
    ]);
    // Column pinning utilities
    /**
	 * Sets the columnPinning state for the table.
	 * @param newColumnWidths -- the new columnPinning state
	 */ const setColumnPinning = (newColumnPinning)=>{
        updateTableState('columnPinning', newColumnPinning, options.onColumnPinningChange);
    };
    /**
	 * @returns the columnPinning state for the table
	 */ const getColumnPinning = ()=>getState().columnPinning;
    /**
	 * Gets the keys of all columns before the given column.
	 */ const getStartColumnKeys = (0, $gwFzn.useCallback)((column)=>getColumnsInOrder().slice(0, getColumnIndex(column)).map((column)=>column.key), [
        getColumnIndex,
        getColumnsInOrder
    ]);
    /**
	 * Gets the keys of all columns after the given column.
	 */ const getEndColumnKeys = (0, $gwFzn.useCallback)((column)=>getColumnsInOrder().slice(getColumnIndex(column) + 1).map((column)=>column.key), [
        getColumnIndex,
        getColumnsInOrder
    ]);
    /**
	 * Sets the columnPinning state for the table where columns to the start or end of the given column are pinned.
	 * @param column the column to pin columns to the start or end of
	 * @param position the position to pin the columns to
	 */ const setBulkColumnPinning = (column, position)=>{
        setColumnPinning((prevColumnPinning)=>{
            const startColumnKeys = getStartColumnKeys(column);
            const endColumnKeys = getEndColumnKeys(column);
            const newColumnPinning = {
                start: position === 'start' ? [
                    ...startColumnKeys,
                    column.key
                ] : prevColumnPinning?.start?.filter((colkey)=>colkey !== column.key) ?? [],
                end: position === 'end' ? [
                    ...endColumnKeys,
                    column.key
                ] : prevColumnPinning?.end?.filter((colkey)=>colkey !== column.key) ?? []
            };
            return newColumnPinning;
        });
    };
    /**
	 * Gets the isPinned value for a column.
	 * @param column  the column to check if it is pinned
	 * @returns the isPinned value for the column
	 */ const getIsPinned = (column)=>{
        const isStartPinned = getColumnPinning()?.start?.includes(column.key);
        const isEndPinned = getColumnPinning()?.end?.includes(column.key);
        return isStartPinned ? 'start' : isEndPinned ? 'end' : false;
    };
    /**
	 * Gets the total width of all columns before the given column.
	 */ const getStartColumnWidths = (0, $gwFzn.useCallback)((column)=>getColumnsInOrder().slice(0, getColumnIndex(column)).reduce((sum, column)=>{
            if (column == null) return sum;
            return sum + getColumnWidth(column);
        }, 0), [
        getColumnIndex,
        getColumnWidth,
        getColumnsInOrder
    ]);
    /**
	 * Gets the total width of all columns after the given column.
	 */ const getEndColumnWidths = (0, $gwFzn.useCallback)((column)=>getColumnsInOrder().slice(getColumnIndex(column) + 1).reduce((sum, column)=>{
            if (column == null) return sum;
            return sum + getColumnWidth(column);
        }, 0), [
        getColumnIndex,
        getColumnWidth,
        getColumnsInOrder
    ]);
    /**
	 * Resets the columnPinning state for the table.
	 * @param column Optional column to reset pinning for. If not provided, all columns are reset.
	 */ const resetColumnPinning = (column)=>{
        setColumnPinning((prevColumnPinning)=>{
            if (!column) return {
                start: [],
                end: []
            };
            const newColumnPinning = {
                start: prevColumnPinning?.start?.includes(column.key) ? [] : prevColumnPinning?.start,
                end: prevColumnPinning?.end?.includes(column.key) ? [] : prevColumnPinning?.end
            };
            return newColumnPinning;
        });
    };
    return {
        getIsCurrentSort: getIsCurrentSort,
        toggleSorting: toggleSorting,
        getSorting: getSorting,
        setSorting: setSorting,
        setColumnOrder: setColumnOrder,
        getColumnsInOrder: getColumnsInOrder,
        getVisibleColumns: getVisibleColumns,
        getColumnOrder: getColumnOrder,
        getColumnWidths: getColumnWidths,
        getColumnWidth: getColumnWidth,
        setColumnWidth: setColumnWidth,
        setColumnWidths: setColumnWidths,
        getTotalTableWidth: getTotalTableWidth,
        getStartColumnWidths: getStartColumnWidths,
        getEndColumnWidths: getEndColumnWidths,
        getColumnIndex: getColumnIndex,
        getColumnPinning: getColumnPinning,
        getIsPinned: getIsPinned,
        setColumnPinning: setColumnPinning,
        getStartColumnKeys: getStartColumnKeys,
        getEndColumnKeys: getEndColumnKeys,
        setBulkColumnPinning: setBulkColumnPinning,
        resetColumnPinning: resetColumnPinning
    };
};
// Row handling utilities
const $6f771d1273db44c7$var$useRows = ({ options: options, rowStruct: rowStruct, getState: getState, updateTableState: updateTableState })=>{
    const setRowSelection = (0, $gwFzn.useCallback)((newRowSelection)=>{
        updateTableState('rowSelection', newRowSelection, options?.onSelectionChange);
    }, [
        options?.onSelectionChange,
        updateTableState
    ]);
    const getCanSelect = (0, $gwFzn.useCallback)((row)=>{
        return options.enableRowSelection;
    }, [
        options
    ]);
    const getIsRowSelected = (0, $gwFzn.useCallback)((row)=>{
        return getState().rowSelection?.[row.id] ?? false;
    }, [
        getState
    ]);
    const toggleRowSelected = (0, $gwFzn.useCallback)((row)=>{
        const rowSelection = getState().rowSelection ?? {};
        const toggleSelect = (innerRow, parentSelection)=>{
            if (getCanSelect(innerRow)) {
                rowSelection[innerRow.id] = parentSelection ?? rowSelection?.[innerRow.id] == null ? true : !rowSelection?.[innerRow.id];
                if (innerRow.subRows) innerRow.subRows.forEach((subRow)=>toggleSelect(subRow, rowSelection[innerRow.id]));
            }
        };
        toggleSelect(row);
        setRowSelection(()=>{
            return {
                ...getState().rowSelection ?? {},
                ...rowSelection
            };
        });
    }, [
        getCanSelect,
        getState,
        setRowSelection
    ]);
    //TODO: implement this
    // const getIsSomeChildrenSelected = useCallback(
    //   (row: FinalCharlieTableRow<TableDataModel>) => {
    //     const checkIfSelected = (innerRow: FinalCharlieTableRow<TableDataModel>) => {
    //       if (row.subRows) {
    //         return row.subRows.some((subRow) => getIsRowSelected(subRow));
    //       }
    //     }
    //     return false;
    //   },
    //   [getIsRowSelected],
    // );
    const getIsSomeRowsSelected = (0, $gwFzn.useCallback)(()=>{
        return Object.values(getState().rowSelection ?? {}).some(Boolean);
    }, [
        getState
    ]);
    const getIsAllRowsSelected = (0, $gwFzn.useCallback)(()=>{
        const rowsExist = rowStruct?.rows?.length ?? false;
        const anySelectionsExist = Object.keys(getState().rowSelection ?? {}).length > 0;
        const hasLength = rowsExist && anySelectionsExist;
        if (hasLength && rowStruct?.rows?.some((row)=>getCanSelect(row) && !getIsRowSelected(row))) return false;
        return hasLength;
    }, [
        getCanSelect,
        getIsRowSelected,
        getState,
        rowStruct?.rows
    ]);
    const toggleAllRowsSelected = (0, $gwFzn.useCallback)(()=>{
        setRowSelection(()=>{
            if (getIsAllRowsSelected()) return {};
            const newSelection = {};
            rowStruct?.flatRows?.forEach((row)=>{
                newSelection[row.id] = getCanSelect(row) ? true : false;
            });
            return newSelection;
        });
    }, [
        getCanSelect,
        getIsAllRowsSelected,
        rowStruct?.flatRows,
        setRowSelection
    ]);
    return {
        toggleRowSelected: toggleRowSelected,
        getIsRowSelected: getIsRowSelected,
        getIsSomeRowsSelected: getIsSomeRowsSelected,
        getIsAllRowsSelected: getIsAllRowsSelected,
        toggleAllRowsSelected: toggleAllRowsSelected,
        getCanSelect: getCanSelect
    };
};
// Main hook
const $6f771d1273db44c7$export$dca832df5e5219b = (options)=>{
    const { getState: getState, updateTableState: updateTableState } = $6f771d1273db44c7$var$useStateManagement(options);
    const state = getState();
    //these need to have a stable reference to avoid re-renders
    const rowStruct = (0, $gwFzn.useMemo)(()=>{
        return (0, $6G1uJ.getRowStructs)({
            rows: options.rows,
            getChildRows: options.getChildRows,
            getRowId: options.getRowId,
            state: {
                expanded: state.expanded
            }
        });
    }, [
        options.rows,
        options.getChildRows,
        options.getRowId,
        state.expanded
    ]);
    const rows = (0, $gwFzn.useMemo)(()=>{
        return rowStruct.rows;
    }, [
        rowStruct
    ]);
    const columnHandlers = $6f771d1273db44c7$var$useColumnUtils({
        options: options,
        getState: getState,
        updateTableState: updateTableState
    });
    const rowHandlers = $6f771d1273db44c7$var$useRows({
        options: options,
        rowStruct: rowStruct,
        getState: getState,
        updateTableState: updateTableState
    });
    const rowExpansion = (0, $ablid.useRowExpansion)({
        options: options,
        getState: getState,
        updateTableState: updateTableState
    });
    // Expose table state management functions and helper functions
    return {
        rows: rows,
        columns: options.columns,
        /**
		 * @private
		 * @deprecated getSubRows will be refactored in future versions.
		 * Use renderChildComponent instead for the existing behavior.
		 */ getSubRows: options.getSubRows,
        rowStruct: rowStruct,
        getChildRows: options.getChildRows,
        state: getState(),
        ...columnHandlers,
        ...rowHandlers,
        ...rowExpansion
    };
};

});
parcelRegister("6G1uJ", function(module, exports) {

$parcel$export(module.exports, "getRowStructs", () => $af8ac79b82599a99$export$8cbc613e8d24798a);
const $af8ac79b82599a99$export$8cbc613e8d24798a = (options)=>{
    const rowStruct = {
        rows: [],
        flatRows: [],
        rowsById: {}
    };
    const recurseRows = ({ originalRows: originalRows, depth: depth = 0, parent: parent })=>{
        const rows = [];
        originalRows.forEach((row, index)=>{
            const finalRow = {
                ...row,
                depth: depth,
                index: index,
                parent: parent,
                id: options.getRowId?.({
                    row: row,
                    index: index,
                    parent: parent
                }) ?? `${parent ? [
                    parent.id,
                    index
                ].join('.') : index}`,
                subRows: undefined
            };
            rowStruct.flatRows.push(finalRow);
            rowStruct.rowsById[finalRow.id] = finalRow;
            rows.push(finalRow);
            if (options.getChildRows) {
                const originalSubRows = options.getChildRows(row);
                if (originalSubRows?.length) finalRow.subRows = recurseRows({
                    originalRows: originalSubRows,
                    depth: depth + 1,
                    parent: finalRow
                });
            }
        });
        return rows;
    };
    if (options.rows == null) return rowStruct;
    rowStruct.rows = recurseRows({
        originalRows: options.rows
    });
    const expanded = [];
    const recurseExpanded = (rows)=>{
        rows.forEach((row)=>{
            expanded.push(row);
            if (row.subRows?.length && options.state?.expanded?.[row.id] === true) recurseExpanded(row.subRows);
        });
    };
    if (options.getChildRows) {
        recurseExpanded(rowStruct.rows);
        rowStruct.rows = expanded;
    }
    return rowStruct;
};

});

parcelRegister("ablid", function(module, exports) {

$parcel$export(module.exports, "useRowExpansion", () => $cb85567b3a00e037$export$85f5d34a3e5ea06e);

var $gwFzn = parcelRequire("gwFzn");
const $cb85567b3a00e037$export$85f5d34a3e5ea06e = ({ options: options, getState: getState, updateTableState: updateTableState })=>{
    const setExpand = (0, $gwFzn.useCallback)((newExpand)=>{
        updateTableState('expanded', newExpand, options?.onExpandChange);
    }, [
        options?.onExpandChange,
        updateTableState
    ]);
    const toggleExpandedRow = (0, $gwFzn.useCallback)((row)=>{
        setExpand((prevExpanded)=>{
            if (prevExpanded?.[row.id] === undefined && row.isDefaultExpanded) return {
                ...prevExpanded,
                [row.id]: false
            };
            if (prevExpanded?.[row.id] === undefined) return {
                ...prevExpanded,
                [row.id]: true
            };
            return {
                ...prevExpanded,
                [row.id]: !prevExpanded[row.id]
            };
        });
    }, [
        setExpand
    ]);
    const getIsRowExpanded = (0, $gwFzn.useCallback)((row)=>{
        return getState().expanded?.[row.id] ?? row.isDefaultExpanded ?? false;
    }, [
        getState
    ]);
    //TODO: add callback for getIsRowExpandable to table hook to decide if row is expandable
    return {
        toggleExpandedRow: toggleExpandedRow,
        getIsRowExpanded: getIsRowExpanded,
        setExpand: setExpand
    };
};

});


parcelRegister("lsKPt", function(module, exports) {

$parcel$export(module.exports, "Table", () => $a1cf136e794f3271$export$54ec01a60f47d33d);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $a1cf136e794f3271$var$tableStyle = (0, $ecnYn.xcss)({
    margin: 'space.0',
    width: '100%'
});
const $a1cf136e794f3271$export$54ec01a60f47d33d = ({ children: children, testId: testId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $a1cf136e794f3271$var$tableStyle,
        testId: testId,
        ...props,
        as: "table"
    }, children);

});

parcelRegister("hOfan", function(module, exports) {

$parcel$export(module.exports, "TableSection", () => $06f16d7a60cc799a$export$1ec001aab6880b05);

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
const $06f16d7a60cc799a$export$1ec001aab6880b05 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), props, children);

});

parcelRegister("h4JwO", function(module, exports) {

$parcel$export(module.exports, "TableRow", () => $8cd9deb67c9d4459$export$b05581f4e764e162);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $8cd9deb67c9d4459$var$rowBaseStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100',
    height: '50px',
    alignItems: 'center',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'color.border'
});
const $8cd9deb67c9d4459$var$rowNoBorderStyle = (0, $ecnYn.xcss)({
    borderBottom: 'none'
});
const $8cd9deb67c9d4459$var$rowSelectedStyle = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected'
});
const $8cd9deb67c9d4459$var$rowFlexibleHeightStyle = (0, $ecnYn.xcss)({
    height: 'auto'
});
const $8cd9deb67c9d4459$var$rowButtonStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer'
});
const $8cd9deb67c9d4459$var$rowDataStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    transitionDuration: '0.1s',
    transitionProperty: 'background-color',
    transitionTimingFunction: 'ease-out',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    }
});
const $8cd9deb67c9d4459$export$b05581f4e764e162 = ({ children: children, noBorder: noBorder, onClick: onClick, isSelected: isSelected, isFlexibleHeight: isFlexibleHeight, isDataRow: isDataRow, ...props })=>{
    const buttonProps = {
        onClick: onClick,
        onKeyDown: (event)=>{
            if (event.key === 'Enter') {
                event.preventDefault();
                onClick?.();
            }
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        as: "tr",
        xcss: [
            $8cd9deb67c9d4459$var$rowBaseStyle,
            Boolean(noBorder) && $8cd9deb67c9d4459$var$rowNoBorderStyle,
            Boolean(onClick) && $8cd9deb67c9d4459$var$rowButtonStyles,
            Boolean(isDataRow) && $8cd9deb67c9d4459$var$rowDataStyles,
            Boolean(isSelected) && $8cd9deb67c9d4459$var$rowSelectedStyle,
            Boolean(isFlexibleHeight) && $8cd9deb67c9d4459$var$rowFlexibleHeightStyle
        ],
        ...props,
        ...onClick ? buttonProps : {},
        testId: props.testId
    }, children);
};

});

parcelRegister("d07OI", function(module, exports) {

$parcel$export(module.exports, "TableCell", () => $51741b1d485786c9$export$1e4baea7053fc0e3);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $51741b1d485786c9$var$cellBaseStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $51741b1d485786c9$var$startAlignStyle = (0, $ecnYn.xcss)({
    textAlign: 'start'
});
const $51741b1d485786c9$var$width100CellStyle = (0, $ecnYn.xcss)({
    width: '100%'
});
const $51741b1d485786c9$var$width70CellStyle = (0, $ecnYn.xcss)({
    width: '70%'
});
const $51741b1d485786c9$var$width60CellStyle = (0, $ecnYn.xcss)({
    width: '60%'
});
const $51741b1d485786c9$var$width50CellStyle = (0, $ecnYn.xcss)({
    width: '50%'
});
const $51741b1d485786c9$var$width40CellStyle = (0, $ecnYn.xcss)({
    width: '40%'
});
const $51741b1d485786c9$var$width30CellStyle = (0, $ecnYn.xcss)({
    width: '30%'
});
const $51741b1d485786c9$var$width20CellStyle = (0, $ecnYn.xcss)({
    width: '20%'
});
const $51741b1d485786c9$var$width10CellStyle = (0, $ecnYn.xcss)({
    width: '10%'
});
const $51741b1d485786c9$var$sortableCellStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.250'
});
const $51741b1d485786c9$export$1e4baea7053fc0e3 = ({ children: children, size: size, isSortable: isSortable, as: as, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        as: as,
        xcss: [
            $51741b1d485786c9$var$cellBaseStyle,
            as === 'th' && $51741b1d485786c9$var$startAlignStyle,
            (size === '100' || size === 'full') && $51741b1d485786c9$var$width100CellStyle,
            (size === '70' || size === 'xxlarge') && $51741b1d485786c9$var$width70CellStyle,
            size === '60' && $51741b1d485786c9$var$width60CellStyle,
            (size === '50' || size === 'xlarge') && $51741b1d485786c9$var$width50CellStyle,
            (size === '40' || size === 'large') && $51741b1d485786c9$var$width40CellStyle,
            (size === '30' || size === 'medium') && $51741b1d485786c9$var$width30CellStyle,
            (size === '20' || size === 'small') && $51741b1d485786c9$var$width20CellStyle,
            (size === '10' || size === 'xsmall') && $51741b1d485786c9$var$width10CellStyle,
            Boolean(isSortable) && $51741b1d485786c9$var$sortableCellStyle
        ],
        ...props
    }, children);

});



//# sourceMappingURL=AnalyticsByLine.081c24d9.js.map
